import { useShipTo } from "contexts/ShipToProvider";
import { ShipTo } from "models/ShipTo";
import { FC } from "react";
import { Col, Row } from "react-bootstrap";
import ApModalDialog, { ApModalProps } from "components/Shared/ApModalDialog";
import { DefaultCompProps } from "./type";
import { FormattedMessage, useIntl } from "react-intl";

const ShiptoPopup: FC<DefaultCompProps & ApModalProps & Record<string, any>> = (props) => {
    const { loading, shipTos, selectShipTo } = useShipTo();
    const { show, onHide, backdrop, keyboard, autoFocus, style, className, ...otherProps } = props;
    const intl = useIntl();

    const shipToClicked = (shipTo: ShipTo) => {
        selectShipTo(shipTo.shipToNumber);
        onHide && onHide();
        //window.location.href = salesOrgOnlineShopUrl(shipTo.salesOrg);
    };

    const shipToContent = (shipTos ?? [] as ShipTo[]).map(s => <>
        <Row>
            <Col md={3} style={{ cursor: 'pointer', color: '#00a8e1' }} onClick={() => shipToClicked(s)}>{s.shipToNumber}</Col>
            <Col md={4}>{s.companyName}</Col>
            <Col md={4}>{`${s.address} ${s.city} ${s.postalCode}`}</Col>
            <Col md={1}></Col>
        </Row>
    </>);

    return <ApModalDialog props={{ show, onHide, backdrop, keyboard, autoFocus }} header={true} headerText={intl.formatMessage({ id: 'ml_114714', defaultMessage: 'X - Change Selected Ship To'})} footer={true}>
        <Row>
            <Col md={3}><FormattedMessage id="ml_114711" defaultMessage="X - Ship To #"/></Col>
            <Col md={4}><FormattedMessage id="ml_114712" defaultMessage="X - Company Name"/></Col>
            <Col md={4}><FormattedMessage id="ml_114713" defaultMessage="X - Town"/></Col>
            <Col md={1}></Col>
        </Row>
        {loading ? <FormattedMessage id="ml_114715" defaultMessage="X - Loading..."/> : shipToContent}
        <Row><FormattedMessage id="ml_114716" defaultMessage="X - If you do not see your ship to displayed, please Click here to update Ship-To List"/></Row>
    </ApModalDialog>;
};
export default ShiptoPopup;
